import BusinessDiscoveryDashboard from './BusinessDiscoveryDashboard'

function App() {
  return <BusinessDiscoveryDashboard />
}

export default App
